import { render, staticRenderFns } from "./ResumeQuote.vue?vue&type=template&id=4ae08a35&scoped=true"
import script from "./ResumeQuote.vue?vue&type=script&lang=js"
export * from "./ResumeQuote.vue?vue&type=script&lang=js"
import style0 from "./ResumeQuote.vue?vue&type=style&index=0&id=4ae08a35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae08a35",
  null
  
)

export default component.exports